<template>
  <div>
    <!-- 活动标题 -->
    <div v-wechat-title="'最强蜗牛三周年年度报告'"></div>
    <div :class="'home-wrapper-3 home-' + homeShow">
      <div class="triennial-home-page" id="triennial-home-page">
        <div class="main">
          <div class="container">
            <div class="swiper-bg">
              <div class="swiper-bg-warp">
                <!-- 禁用鼠标拖动swiper-no-swiping -->
                <div class="swiper-wrapper swiper-no-swiping">
                  <div class="swiper-slide">
                    <div
                      :class="isAgain ? 'content-box-1' : 'content-box'"
                      :style="slideStyle"
                    >
                      <div class="year animated bounce iteration"></div>
                      <div class="title"></div>
                      <div class="billboard"></div>
                      <div class="btn-box">
                        <div
                          :class="
                            userInfo.times > 0
                              ? 'lottery-btn animated swing iteration duration2s'
                              : 'lottery-btn'
                          "
                          @click="isShowLotteryDialog"
                        >
                          <div
                            class="red"
                            v-if="!userInfo.phone && userInfo.is_get_prize"
                          ></div>
                        </div>
                        <div
                          class="detail-btn"
                          @click="isShowActivityDetailDialog"
                        ></div>
                        <div
                          class="music-btn"
                          v-if="isShowMusicBtn"
                          @click="musicClick(false)"
                        ></div>
                        <div
                          v-else
                          class="music-close"
                          @click="musicClick(true)"
                        ></div>
                      </div>
                      <div class="btn-box-1">
                        <div
                          v-if="!userInfo.role_name"
                          class="login-btn"
                          @click.stop="changeLoginPopup(true)"
                        ></div>
                        <div
                          v-if="
                            userInfo.role_name && !isChannel(userInfo.channel)
                          "
                          class="change-btn"
                          @click.stop="changeOsPopup(true)"
                        >
                          <div class="user-info" v-if="userInfo.role_name">
                            <p>
                              {{ userInfo.server_name
                              }}{{ userInfo.server_id }}服
                            </p>
                            <p>{{ userInfo.role_name }}</p>
                          </div>
                        </div>
                        <div
                          v-if="
                            userInfo.role_name && isChannel(userInfo.channel)
                          "
                          class="exit"
                          @click.stop="logout"
                        >
                          <div class="user-info" v-if="userInfo.role_name">
                            <p>
                              {{ userInfo.server_name
                              }}{{ userInfo.server_id }}服
                            </p>
                            <p>{{ userInfo.role_name }}</p>
                          </div>
                        </div>
                        <div
                          class="official-website-btn"
                          @click.stop="gotoWeb"
                        ></div>
                      </div>
                      <div
                        v-if="!isAgain"
                        class="start-btn"
                        @click.stop="nextPage"
                      ></div>
                      <div v-if="isAgain" class="again-div">
                        <div class="again-btn" @click="nextPage"></div>
                        <div
                          class="final-report"
                          @click="shareShow = true"
                        ></div>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="first-act-box" :style="slideStyle">
                      <div
                        :class="
                          isAnimateList[1].isPlayAnimate
                            ? 'seance animated slideInDown delay5s'
                            : 'seance'
                        "
                        v-if="swiperIndex == 1"
                      ></div>
                      <div class="email">
                        <div class="star"></div>
                      </div>
                      <div class="projector-lamp"></div>
                      <div class="spotlight"></div>
                      <div
                        :class="
                          isAnimateList[1].isPlayAnimate
                            ? 'snail animated fadeInLeftBig delay5s'
                            : 'snail'
                        "
                        v-if="swiperIndex == 1"
                      ></div>
                      <div
                        :class="
                          isAnimateList[1].isPlayAnimate
                            ? 'shiba-inu animated fadeInRightBig'
                            : 'shiba-inu'
                        "
                        v-if="swiperIndex == 1"
                      ></div>
                      <div
                        :class="
                          isAnimateList[1].isPlayAnimate
                            ? 'wizard animated fadeInRightBig'
                            : 'wizard'
                        "
                        v-if="swiperIndex == 1"
                      ></div>
                      <div
                        :class="
                          isAnimateList[1].isPlayAnimate
                            ? 'killer animated fadeInRightBig'
                            : 'killer'
                        "
                        v-if="swiperIndex == 1"
                      ></div>
                      <div class="curtain"></div>
                      <div
                        :class="
                          isAnimateList[1].isPlayAnimate
                            ? 'dialog-box-1 animated zoomIn delay125s'
                            : 'dialog-box-1'
                        "
                        v-if="swiperIndex == 1"
                      >
                        <p>
                          还记得<span>{{
                            dateText(user_activity.create_time * 1000)
                          }}</span>
                          ，蜗正准备去码头整点薯条的蜗，误入大眼珠子的传销骗局，差点被送到了缅北！
                        </p>
                      </div>
                      <div
                        :class="
                          isAnimateList[1].isPlayAnimate
                            ? 'dialog-box-2 animated zoomIn delay15s'
                            : 'dialog-box-2'
                        "
                        v-if="swiperIndex == 1"
                      >
                        <p class="p-style" v-if="user_activity.sign >= 10">
                          在这鬼地方待的<span class="span-style">{{
                            user_activity.sign
                          }}</span
                          >天, 虽然战力提升至了<span class="span-style">{{
                            totalScoreText(user_activity.total_score)
                          }}</span
                          ><span v-if="isShowMyriad">{{
                            user_activity.total_score > 100000000 ? "亿" : "万"
                          }}</span
                          >，但就没有一天是不挨揍的！
                        </p>
                        <p v-else class="p-style1">
                          本蜗初来乍到！虽然战力只有<span class="span-style">{{
                            totalScoreText(user_activity.total_score)
                          }}</span
                          ><span v-if="isShowMyriad">{{
                            user_activity.total_score > 100000000 ? "亿" : "万"
                          }}</span
                          >，但蜗也不是好欺负的！
                        </p>
                      </div>
                      <div
                        class="email-wrap"
                        @click="requestEasterEggReward('1')"
                      ></div>
                      <div class="btn-box">
                        <div
                          :class="
                            userInfo.times > 0
                              ? 'lottery-btn animated swing iteration duration2s'
                              : 'lottery-btn'
                          "
                          @click="isShowLotteryDialog"
                        >
                          <div
                            class="red"
                            v-if="!userInfo.phone && userInfo.is_get_prize"
                          ></div>
                        </div>
                        <div
                          class="detail-btn"
                          @click="isShowActivityDetailDialog"
                        ></div>
                        <div
                          class="music-btn"
                          v-if="isShowMusicBtn"
                          @click="musicClick(false)"
                        ></div>
                        <div
                          v-else
                          class="music-close"
                          @click="musicClick(true)"
                        ></div>
                      </div>
                      <div class="btn-box-1">
                        <div
                          v-if="!userInfo.role_name"
                          class="login-btn"
                          @click.stop="changeLoginPopup(true)"
                        ></div>
                        <div
                          v-if="
                            userInfo.role_name && !isChannel(userInfo.channel)
                          "
                          class="change-btn"
                          @click.stop="changeOsPopup(true)"
                        >
                          <div class="user-info" v-if="userInfo.role_name">
                            <p>
                              {{ userInfo.server_name
                              }}{{ userInfo.server_id }}服
                            </p>
                            <p>{{ userInfo.role_name }}</p>
                          </div>
                        </div>
                        <div
                          v-if="
                            userInfo.role_name && isChannel(userInfo.channel)
                          "
                          class="exit"
                          @click.stop="logout"
                        >
                          <div class="user-info" v-if="userInfo.role_name">
                            <p>
                              {{ userInfo.server_name
                              }}{{ userInfo.server_id }}服
                            </p>
                            <p>{{ userInfo.role_name }}</p>
                          </div>
                        </div>
                        <div
                          class="official-website-btn"
                          @click.stop="gotoWeb"
                        ></div>
                      </div>
                      <div
                        :class="
                          isGreaterThan5S && isAnimateList[1].isPlayAnimate
                            ? 'up-btn animated tada iteration'
                            : 'up-btn'
                        "
                        @click.stop="upPage"
                      ></div>
                      <div
                        :class="
                          isGreaterThan5S && isAnimateList[1].isPlayAnimate
                            ? 'next-btn animated tada iteration'
                            : 'next-btn'
                        "
                        @click.stop="nextPage"
                      ></div>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="second-act-box" :style="slideStyle">
                      <div class="seance">
                        <div class="star"></div>
                      </div>
                      <div class="projector-lamp"></div>
                      <div class="spotlight"></div>
                      <div
                        :class="
                          isAnimateList[2].isPlayAnimate
                            ? 'alchemy-furnace animated fadeIn'
                            : 'alchemy-furnace'
                        "
                        v-if="swiperIndex == 2"
                      ></div>
                      <div
                        :class="
                          isAnimateList[2].isPlayAnimate
                            ? 'snail animated fadeInLeftBig delay5s'
                            : 'snail'
                        "
                        v-if="swiperIndex == 2"
                      ></div>
                      <div
                        :class="
                          isAnimateList[2].isPlayAnimate
                            ? 'lottery-machine animated fadeIn delay5s'
                            : 'lottery-machine'
                        "
                        v-if="swiperIndex == 2"
                      ></div>
                      <div class="curtain"></div>
                      <div
                        :class="
                          isAnimateList[2].isPlayAnimate
                            ? 'dialog-box-1 animated zoomIn delay125s'
                            : 'dialog-box-1'
                        "
                        v-if="swiperIndex == 2"
                      >
                        <p
                          v-if="
                            user_activity.resource_product_1 +
                              user_activity.resource_product_2 +
                              user_activity.resource_product_3 +
                              user_activity.resource_product_4 +
                              user_activity.resource_product_5 >=
                              10
                          "
                        >
                          现在蜗已经将后院总等级升至<span>{{
                            user_activity.resource_product_1 +
                              user_activity.resource_product_2 +
                              user_activity.resource_product_3 +
                              user_activity.resource_product_4 +
                              user_activity.resource_product_5
                          }}</span
                          >级！嗯...养老时间到！
                        </p>
                        <p v-else>
                          现在蜗已经将后院总等级是<span>{{
                            user_activity.resource_product_1 +
                              user_activity.resource_product_2 +
                              user_activity.resource_product_3 +
                              user_activity.resource_product_4 +
                              user_activity.resource_product_5
                          }}</span
                          >级...嗯，该干活了！
                        </p>
                      </div>
                      <div
                        :class="
                          isAnimateList[2].isPlayAnimate
                            ? 'dialog-box-2 animated zoomIn delay15s'
                            : 'dialog-box-2'
                        "
                        v-if="swiperIndex == 2"
                      >
                        <p v-if="user_activity.wish > 0">
                          蜗一共进行了<span>{{ user_activity.wish }}</span
                          >次许愿！希望来年顺风顺水，每抽出橙！
                        </p>
                        <p v-else>
                          貌似蜗还没捡到八卦炉，许愿币还没用出去过呢！！
                        </p>
                      </div>
                      <div
                        :class="
                          isAnimateList[2].isPlayAnimate
                            ? 'dialog-box-3 animated zoomIn delay175s'
                            : 'dialog-box-3'
                        "
                        v-if="swiperIndex == 2"
                      >
                        <p v-if="user_activity.lottery_count > 0">
                          根据主板记录显示...蜗今年一共消耗了<span>{{
                            user_activity.lottery_count
                          }}</span
                          >张抽奖券！可是...贵重品怎么就不见多呢！
                        </p>
                        <p v-else>
                          根据主板记录显示...蜗还没进行过抽奖，猴子快给蜗发100抽先来爽爽！
                        </p>
                      </div>
                      <div
                        class="seance-wrap"
                        @click.stop="requestEasterEggReward('2')"
                      ></div>
                      <div class="btn-box">
                        <div
                          :class="
                            userInfo.times > 0
                              ? 'lottery-btn animated swing iteration duration2s'
                              : 'lottery-btn'
                          "
                          @click="isShowLotteryDialog"
                        >
                          <div
                            class="red"
                            v-if="!userInfo.phone && userInfo.is_get_prize"
                          ></div>
                        </div>
                        <div
                          class="detail-btn"
                          @click="isShowActivityDetailDialog"
                        ></div>
                        <div
                          class="music-btn"
                          v-if="isShowMusicBtn"
                          @click="musicClick(false)"
                        ></div>
                        <div
                          v-else
                          class="music-close"
                          @click="musicClick(true)"
                        ></div>
                      </div>
                      <div class="btn-box-1">
                        <div
                          v-if="!userInfo.role_name"
                          class="login-btn"
                          @click.stop="changeLoginPopup(true)"
                        ></div>
                        <div
                          v-if="
                            userInfo.role_name && !isChannel(userInfo.channel)
                          "
                          class="change-btn"
                          @click.stop="changeOsPopup(true)"
                        >
                          <div class="user-info" v-if="userInfo.role_name">
                            <p>
                              {{ userInfo.server_name
                              }}{{ userInfo.server_id }}服
                            </p>
                            <p>{{ userInfo.role_name }}</p>
                          </div>
                        </div>
                        <div
                          v-if="
                            userInfo.role_name && isChannel(userInfo.channel)
                          "
                          class="exit"
                          @click.stop="logout"
                        >
                          <div class="user-info" v-if="userInfo.role_name">
                            <p>
                              {{ userInfo.server_name
                              }}{{ userInfo.server_id }}服
                            </p>
                            <p>{{ userInfo.role_name }}</p>
                          </div>
                        </div>
                        <div
                          class="official-website-btn"
                          @click.stop="gotoWeb"
                        ></div>
                      </div>
                      <div
                        :class="
                          isGreaterThan5S && isAnimateList[2].isPlayAnimate
                            ? 'up-btn animated tada iteration'
                            : 'up-btn'
                        "
                        @click.stop="upPage"
                      ></div>
                      <div
                        :class="
                          isGreaterThan5S && isAnimateList[2].isPlayAnimate
                            ? 'next-btn animated tada iteration'
                            : 'next-btn'
                        "
                        @click.stop="nextPage"
                      ></div>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="third-act-box" :style="slideStyle">
                      <div
                        :class="
                          isAnimateList[3].isPlayAnimate
                            ? 'krohn animated fadeInLeftBig delay-1s'
                            : 'krohn'
                        "
                        v-if="swiperIndex == 3"
                      ></div>
                      <div
                        :class="
                          isAnimateList[3].isPlayAnimate
                            ? 'beggar animated fadeInLeftBig delay-1s'
                            : 'beggar'
                        "
                        v-if="swiperIndex == 3"
                      ></div>
                      <div
                        :class="
                          isAnimateList[3].isPlayAnimate
                            ? 'cassock animated fadeInLeftBig delay-1s'
                            : 'cassock'
                        "
                        v-if="swiperIndex == 3"
                      ></div>
                      <div
                        :class="
                          isAnimateList[3].isPlayAnimate
                            ? 'snail animated fadeInLeftBig'
                            : 'snail'
                        "
                        v-if="swiperIndex == 3"
                      ></div>
                      <div
                        :class="
                          isAnimateList[3].isPlayAnimate
                            ? 'shalou animated fadeIn'
                            : 'shalou'
                        "
                        v-if="swiperIndex == 3"
                      >
                        <div class="star"></div>
                      </div>
                      <div
                        :class="
                          isAnimateList[3].isPlayAnimate
                            ? 'godzilla animated fadeInRightBig delay15s'
                            : 'godzilla'
                        "
                        v-if="swiperIndex == 3"
                      ></div>
                      <div
                        :class="
                          isAnimateList[3].isPlayAnimate
                            ? 'ak47 animated fadeInRightBig delay15s'
                            : 'ak47'
                        "
                        v-if="swiperIndex == 3"
                      ></div>
                      <div
                        :class="
                          isAnimateList[3].isPlayAnimate
                            ? 'soldier animated fadeInRightBig delay15s'
                            : 'soldier'
                        "
                        v-if="swiperIndex == 3"
                      ></div>
                      <div
                        :class="
                          isAnimateList[3].isPlayAnimate
                            ? 'ninja animated fadeInRightBig delay15s'
                            : 'ninja'
                        "
                        v-if="swiperIndex == 3"
                      ></div>
                      <div
                        :class="
                          isAnimateList[3].isPlayAnimate
                            ? 'dialog-box-2 animated zoomIn delay-2s'
                            : 'dialog-box-2'
                        "
                        v-if="swiperIndex == 3"
                      >
                        <p
                          class="p-style"
                          v-if="user_activity.partner_count > 0"
                        >
                          探索的路途上蜗也并不孤独，一路上结识的<span>{{
                            user_activity.partner_count
                          }}</span
                          >位小伙伴，都是蜗的得力助手！
                        </p>
                        <p class="p-style1" v-else>
                          蜗有预感，旅途上还有更多伙伴，等着蜗去遇见！
                        </p>
                      </div>
                      <div
                        :class="
                          isAnimateList[3].isPlayAnimate
                            ? 'dialog-box-3 animated zoomIn delay225s'
                            : 'dialog-box-3'
                        "
                        v-if="swiperIndex == 3"
                      >
                        <p v-if="user_activity.boss_challenge >= 20">
                          现在蜗已累计击败了<span>{{
                            user_activity.boss_challenge
                          }}</span
                          >个使徒！咱就是说，鹂们家的使徒是批发的吗，那么多！
                        </p>
                        <p v-else style="top: 1.05rem">
                          现在蜗已累计击败了<span>{{
                            user_activity.boss_challenge
                          }}</span
                          >个使徒！使徒放马过来，蜗要打十个！
                        </p>
                      </div>
                      <div class="curtain"></div>
                      <div
                        :class="
                          isAnimateList[3].isPlayAnimate
                            ? 'dialog-box-1 animated zoomIn delay75s'
                            : 'dialog-box-1'
                        "
                        v-if="swiperIndex == 3"
                      >
                        <p
                          v-if="tourMapText(user_activity.tour_map_count) == ''"
                        >
                          蜗好像还没出门好好逛过... 那么，下一站——高丽！出发！
                        </p>
                        <p
                          v-else-if="
                            tourMapText(user_activity.tour_map_count) ==
                              '时空孔隙'
                          "
                        >
                          据挨揍的使徒所说，现在蜗已经探索至<span>{{
                            tourMapText(user_activity.tour_map_count)
                          }}</span
                          >了！后面还有什么等着蜗呢...
                        </p>
                        <p v-else>
                          据挨揍的使徒所说，现在蜗已经探索至<span>{{
                            tourMapText(user_activity.tour_map_count)
                          }}</span
                          >了！制霸八国，就包在蜗身上吧！
                        </p>
                      </div>
                      <div
                        class="shalou-wrap"
                        @click="requestEasterEggReward('3')"
                      ></div>
                      <div class="btn-box">
                        <div
                          :class="
                            userInfo.times > 0
                              ? 'lottery-btn animated swing iteration duration2s'
                              : 'lottery-btn'
                          "
                          @click="isShowLotteryDialog"
                        >
                          <div
                            class="red"
                            v-if="!userInfo.phone && userInfo.is_get_prize"
                          ></div>
                        </div>
                        <div
                          class="detail-btn"
                          @click="isShowActivityDetailDialog"
                        ></div>
                        <div
                          class="music-btn"
                          v-if="isShowMusicBtn"
                          @click="musicClick(false)"
                        ></div>
                        <div
                          v-else
                          class="music-close"
                          @click="musicClick(true)"
                        ></div>
                      </div>
                      <div class="btn-box-1">
                        <div
                          v-if="!userInfo.role_name"
                          class="login-btn"
                          @click.stop="changeLoginPopup(true)"
                        ></div>
                        <div
                          v-if="
                            userInfo.role_name && !isChannel(userInfo.channel)
                          "
                          class="change-btn"
                          @click.stop="changeOsPopup(true)"
                        >
                          <div class="user-info" v-if="userInfo.role_name">
                            <p>
                              {{ userInfo.server_name
                              }}{{ userInfo.server_id }}服
                            </p>
                            <p>{{ userInfo.role_name }}</p>
                          </div>
                        </div>
                        <div
                          v-if="
                            userInfo.role_name && isChannel(userInfo.channel)
                          "
                          class="exit"
                          @click.stop="logout"
                        >
                          <div class="user-info" v-if="userInfo.role_name">
                            <p>
                              {{ userInfo.server_name
                              }}{{ userInfo.server_id }}服
                            </p>
                            <p>{{ userInfo.role_name }}</p>
                          </div>
                        </div>
                        <div
                          class="official-website-btn"
                          @click.stop="gotoWeb"
                        ></div>
                      </div>
                      <div
                        :class="
                          isGreaterThan5S && isAnimateList[3].isPlayAnimate
                            ? 'up-btn animated tada iteration'
                            : 'up-btn'
                        "
                        @click.stop="upPage"
                      ></div>
                      <div
                        :class="
                          isGreaterThan5S && isAnimateList[3].isPlayAnimate
                            ? 'next-btn animated tada iteration'
                            : 'next-btn'
                        "
                        @click.stop="nextPage"
                      ></div>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div
                      class="fourth-act-box-1"
                      :style="slideStyle"
                      v-if="
                        user_activity.join_group_time == 0 &&
                          user_activity.group_war_join_times == 0
                      "
                    >
                      <div class="box-2">
                        <div class="star"></div>
                      </div>
                      <div class="projector-lamp"></div>
                      <div class="portal"></div>
                      <div
                        :class="
                          isAnimateList[4].isPlayAnimate
                            ? 'blue-snail animated fadeInRightBig delay5s'
                            : 'blue-snail'
                        "
                        v-if="swiperIndex == 4"
                      ></div>
                      <div
                        :class="
                          isAnimateList[4].isPlayAnimate
                            ? 'yellow-snail animated fadeInRightBig delay5s'
                            : 'yellow-snail'
                        "
                        v-if="swiperIndex == 4"
                      ></div>
                      <div
                        :class="
                          isAnimateList[4].isPlayAnimate
                            ? 'snail animated fadeInLeftBig'
                            : 'snail'
                        "
                        v-if="swiperIndex == 4"
                      ></div>
                      <div class="curtain"></div>
                      <div
                        :class="
                          isAnimateList[4].isPlayAnimate
                            ? 'dialog-box-4 animated zoomIn delay125s'
                            : 'dialog-box-4'
                        "
                        v-if="swiperIndex == 4"
                      ></div>
                      <div class="btn-box">
                        <div
                          :class="
                            userInfo.times > 0
                              ? 'lottery-btn animated swing iteration duration2s'
                              : 'lottery-btn'
                          "
                          @click="isShowLotteryDialog"
                        >
                          <div
                            class="red"
                            v-if="!userInfo.phone && userInfo.is_get_prize"
                          ></div>
                        </div>
                        <div
                          class="detail-btn"
                          @click="isShowActivityDetailDialog"
                        ></div>
                        <div
                          class="music-btn"
                          v-if="isShowMusicBtn"
                          @click="musicClick(false)"
                        ></div>
                        <div
                          v-else
                          class="music-close"
                          @click="musicClick(true)"
                        ></div>
                      </div>
                      <div class="btn-box-1">
                        <div
                          v-if="!userInfo.role_name"
                          class="login-btn"
                          @click.stop="changeLoginPopup(true)"
                        ></div>
                        <div
                          v-if="
                            userInfo.role_name && !isChannel(userInfo.channel)
                          "
                          class="change-btn"
                          @click.stop="changeOsPopup(true)"
                        >
                          <div class="user-info" v-if="userInfo.role_name">
                            <p>
                              {{ userInfo.server_name
                              }}{{ userInfo.server_id }}服
                            </p>
                            <p>{{ userInfo.role_name }}</p>
                          </div>
                        </div>
                        <div
                          v-if="
                            userInfo.role_name && isChannel(userInfo.channel)
                          "
                          class="exit"
                          @click.stop="logout"
                        >
                          <div class="user-info" v-if="userInfo.role_name">
                            <p>
                              {{ userInfo.server_name
                              }}{{ userInfo.server_id }}服
                            </p>
                            <p>{{ userInfo.role_name }}</p>
                          </div>
                        </div>
                        <div
                          class="official-website-btn"
                          @click.stop="gotoWeb"
                        ></div>
                      </div>
                      <div
                        class="egg-reward-wrap"
                        @click="requestEasterEggReward('4')"
                      ></div>
                      <div
                        :class="
                          isGreaterThan5S && isAnimateList[4].isPlayAnimate
                            ? 'up-btn animated tada iteration'
                            : 'up-btn'
                        "
                        @click.stop="upPage"
                      ></div>
                      <div
                        :class="
                          isGreaterThan5S && isAnimateList[4].isPlayAnimate
                            ? 'next-btn animated tada iteration'
                            : 'next-btn'
                        "
                        @click.stop="nextPage"
                      ></div>
                    </div>
                    <div class="fourth-act-box" :style="slideStyle" v-else>
                      <div class="box-2">
                        <div class="star"></div>
                      </div>
                      <div class="projector-lamp"></div>
                      <div
                        :class="
                          isAnimateList[4].isPlayAnimate
                            ? 'club-president animated fadeInLeftBig delay75s'
                            : 'club-president'
                        "
                        v-if="swiperIndex == 4"
                      ></div>
                      <div
                        :class="
                          isAnimateList[4].isPlayAnimate
                            ? 'merman animated fadeInLeftBig delay5s'
                            : 'merman'
                        "
                        v-if="swiperIndex == 4"
                      ></div>
                      <div
                        :class="
                          isAnimateList[4].isPlayAnimate
                            ? 'orderly animated fadeInRightBig delay-1s'
                            : 'orderly'
                        "
                        v-if="swiperIndex == 4"
                      ></div>
                      <div
                        :class="
                          isAnimateList[4].isPlayAnimate
                            ? 'tyrannosaurus animated fadeIn'
                            : 'tyrannosaurus'
                        "
                        v-if="swiperIndex == 4"
                      ></div>
                      <div
                        :class="
                          isAnimateList[4].isPlayAnimate
                            ? 'squirrel animated fadeInRightBig delay125s'
                            : 'squirrel'
                        "
                        v-if="swiperIndex == 4"
                      ></div>
                      <div
                        :class="
                          isAnimateList[4].isPlayAnimate
                            ? 'scholar animated fadeInRightBig delay15s'
                            : 'scholar'
                        "
                        v-if="swiperIndex == 4"
                      ></div>
                      <div
                        :class="
                          isAnimateList[4].isPlayAnimate
                            ? 'dialog-box-1 animated zoomIn delay-2s'
                            : 'dialog-box-1'
                        "
                        v-if="swiperIndex == 4"
                      >
                        <p v-if="user_activity.join_group_time > 0">
                          <span>{{
                            dateText(user_activity.join_group_time * 1000)
                          }}</span
                          >在旅途的路上，蜗还碰到了俱乐部的小伙伴！笑死，原来被拐来的不是只有蜗一个！
                        </p>
                        <p v-else class="p-style">
                          今天，蜗还在寻找新俱乐部的路上！蜗一直在寻找，有鹂的俱乐部在哪里~
                        </p>
                      </div>
                      <div
                        :class="
                          isAnimateList[4].isPlayAnimate
                            ? 'dialog-box-2 animated zoomIn delay225s'
                            : 'dialog-box-2'
                        "
                        v-if="swiperIndex == 4"
                      >
                        <p
                          v-if="user_activity.group_war_join_times == 0"
                          class="p-style2"
                        >
                          再不开门蜗就要抡锤子砸门了！
                        </p>
                        <p
                          class="p-style"
                          v-if="
                            user_activity.max_kit_amount[0] != -1 &&
                              user_activity.group_war_join_times > 0
                          "
                        >
                          在物种战争中，<span class="span-style">{{
                            suitText(user_activity.max_kit_amount)
                          }}</span
                          >最受蜗的喜爱！<span
                            v-if="
                              suitText(user_activity.max_kit_amount) ==
                                '勘探套件'
                            "
                            >钻地铺路的事件，就交给蜗吧！</span
                          ><span
                            v-if="
                              suitText(user_activity.max_kit_amount) ==
                                '苦力套件'
                            "
                            >打架的事情就让大佬来吧！</span
                          ><span
                            v-if="
                              suitText(user_activity.max_kit_amount) ==
                                '敢死套件'
                            "
                            >不管鹂是谁，蜗来通通创飞！</span
                          >
                        </p>
                        <p
                          class="p-style1"
                          v-if="
                            user_activity.max_kit_amount[0] == -1 &&
                              user_activity.group_war_join_times > 0
                          "
                        >
                          再不开门蜗就去玩不思议迷宫了！
                        </p>
                      </div>
                      <div
                        :class="
                          isAnimateList[4].isPlayAnimate
                            ? 'snail animated fadeInLeftBig'
                            : 'snail'
                        "
                        v-if="swiperIndex == 4"
                      ></div>
                      <div class="curtain"></div>
                      <div
                        :class="
                          isAnimateList[4].isPlayAnimate
                            ? 'dialog-box-3 animated zoomIn delay250s'
                            : 'dialog-box-3'
                        "
                        v-if="swiperIndex == 4"
                      >
                        <p v-if="user_activity.group_war_join_times > 0">
                          蜗已经参与了<span>{{
                            user_activity.group_war_join_times
                          }}</span
                          >次物种战争了！诸君，我喜欢战争！
                        </p>
                        <p class="p-style" v-else>
                          蜗好像还没参与过物种战争，快给蜗开传送门！
                        </p>
                      </div>
                      <div class="btn-box">
                        <div
                          :class="
                            userInfo.times > 0
                              ? 'lottery-btn animated swing iteration duration2s'
                              : 'lottery-btn'
                          "
                          @click="isShowLotteryDialog"
                        >
                          <div
                            class="red"
                            v-if="!userInfo.phone && userInfo.is_get_prize"
                          ></div>
                        </div>
                        <div
                          class="detail-btn"
                          @click="isShowActivityDetailDialog"
                        ></div>
                        <div
                          class="music-btn"
                          v-if="isShowMusicBtn"
                          @click="musicClick(false)"
                        ></div>
                        <div
                          v-else
                          class="music-close"
                          @click="musicClick(true)"
                        ></div>
                      </div>
                      <div class="btn-box-1">
                        <div
                          v-if="!userInfo.role_name"
                          class="login-btn"
                          @click.stop="changeLoginPopup(true)"
                        ></div>
                        <div
                          v-if="
                            userInfo.role_name && !isChannel(userInfo.channel)
                          "
                          class="change-btn"
                          @click.stop="changeOsPopup(true)"
                        >
                          <div class="user-info" v-if="userInfo.role_name">
                            <p>
                              {{ userInfo.server_name
                              }}{{ userInfo.server_id }}服
                            </p>
                            <p>{{ userInfo.role_name }}</p>
                          </div>
                        </div>
                        <div
                          v-if="
                            userInfo.role_name && isChannel(userInfo.channel)
                          "
                          class="exit"
                          @click.stop="logout"
                        >
                          <div class="user-info" v-if="userInfo.role_name">
                            <p>
                              {{ userInfo.server_name
                              }}{{ userInfo.server_id }}服
                            </p>
                            <p>{{ userInfo.role_name }}</p>
                          </div>
                        </div>
                        <div
                          class="official-website-btn"
                          @click.stop="gotoWeb"
                        ></div>
                      </div>
                      <div
                        class="egg-reward-wrap"
                        @click="requestEasterEggReward('4')"
                      ></div>
                      <div
                        :class="
                          isGreaterThan5S && isAnimateList[4].isPlayAnimate
                            ? 'up-btn animated tada iteration'
                            : 'up-btn'
                        "
                        @click.stop="upPage"
                      ></div>
                      <div
                        :class="
                          isGreaterThan5S && isAnimateList[4].isPlayAnimate
                            ? 'next-btn animated tada iteration'
                            : 'next-btn'
                        "
                        @click.stop="nextPage"
                      ></div>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div
                      class="fifth-act-box"
                      :style="slideStyle"
                      v-if="user_activity.pet_book_count > 0"
                    >
                      <div class="projector-lamp"></div>
                      <div
                        :class="
                          isAnimateList[5].isPlayAnimate
                            ? 'tiger-left animated fadeInLeftBig delay5s'
                            : 'tiger-left'
                        "
                        v-if="swiperIndex == 5"
                      ></div>
                      <div
                        :class="
                          isAnimateList[5].isPlayAnimate
                            ? 'snake animated fadeInLeftBig delay5s'
                            : 'snake'
                        "
                        v-if="swiperIndex == 5"
                      ></div>
                      <div
                        :class="
                          isAnimateList[5].isPlayAnimate
                            ? 'snail animated fadeInLeftBig'
                            : 'snail'
                        "
                        v-if="swiperIndex == 5"
                      ></div>
                      <div
                        :class="
                          isAnimateList[5].isPlayAnimate
                            ? 'dragon animated fadeInLeftBig delay5s'
                            : 'dragon'
                        "
                        v-if="swiperIndex == 5"
                      ></div>
                      <div
                        :class="
                          isAnimateList[5].isPlayAnimate
                            ? 'deer animated fadeInRightBig delay5s'
                            : 'deer'
                        "
                        v-if="swiperIndex == 5"
                      ></div>
                      <div
                        :class="
                          isAnimateList[5].isPlayAnimate
                            ? 'tiger-right animated fadeInRightBig delay5s'
                            : 'tiger-right'
                        "
                        v-if="swiperIndex == 5"
                      ></div>
                      <div
                        :class="
                          isAnimateList[5].isPlayAnimate
                            ? 'dialog-box-1 animated zoomIn delay15s'
                            : 'dialog-box-1'
                        "
                        v-if="swiperIndex == 5"
                      >
                        <p>
                          无论是在哪里，有抽奖的地方就肯定少不了蜗，至今蜗已经完成了<span
                            >{{ user_activity.pet_lottery_consume }}</span
                          >次催化！
                        </p>
                      </div>
                      <div
                        :class="
                          isAnimateList[5].isPlayAnimate
                            ? 'dialog-box-2 animated zoomIn delay125s'
                            : 'dialog-box-2'
                        "
                        v-if="swiperIndex == 5"
                      >
                        <p>
                          今年猴子又挖了新坑，虽然一开始蜗是拒绝的，但现在，蜗的图鉴已经解锁了<span
                            >{{ user_activity.pet_book_count }}</span
                          >只源兽了！
                        </p>
                      </div>
                      <div
                        :class="
                          isAnimateList[5].isPlayAnimate
                            ? 'dialog-box-3 animated zoomIn delay175s'
                            : 'dialog-box-3'
                        "
                        v-if="swiperIndex == 5"
                      >
                        <p v-if="user_activity.pet_hunting_join_times > 0">
                          在今年<span>{{
                            user_activity.pet_hunting_join_times
                          }}</span
                          >次部落战争中，蜗一共消耗了<span>{{
                            user_activity.patrol_lottery_consume
                          }}</span
                          >个征募令，老虎机已经快被蜗摇出火花了！
                        </p>
                        <p v-else>
                          貌似蜗还没参加过部落战争，是时候该让蜗的源兽们大显身手了！
                        </p>
                      </div>
                      <div class="curtain"></div>
                      <div class="btn-box">
                        <div
                          :class="
                            userInfo.times > 0
                              ? 'lottery-btn animated swing iteration duration2s'
                              : 'lottery-btn'
                          "
                          @click="isShowLotteryDialog"
                        >
                          <div
                            class="red"
                            v-if="!userInfo.phone && userInfo.is_get_prize"
                          ></div>
                        </div>
                        <div
                          class="detail-btn"
                          @click="isShowActivityDetailDialog"
                        ></div>
                        <div
                          class="music-btn"
                          v-if="isShowMusicBtn"
                          @click="musicClick(false)"
                        ></div>
                        <div
                          v-else
                          class="music-close"
                          @click="musicClick(true)"
                        ></div>
                      </div>
                      <div class="btn-box-1">
                        <div
                          v-if="!userInfo.role_name"
                          class="login-btn"
                          @click.stop="changeLoginPopup(true)"
                        ></div>
                        <div
                          v-if="
                            userInfo.role_name && !isChannel(userInfo.channel)
                          "
                          class="change-btn"
                          @click.stop="changeOsPopup(true)"
                        >
                          <div class="user-info" v-if="userInfo.role_name">
                            <p>
                              {{ userInfo.server_name
                              }}{{ userInfo.server_id }}服
                            </p>
                            <p>{{ userInfo.role_name }}</p>
                          </div>
                        </div>
                        <div
                          v-if="
                            userInfo.role_name && isChannel(userInfo.channel)
                          "
                          class="exit"
                          @click.stop="logout"
                        >
                          <div class="user-info" v-if="userInfo.role_name">
                            <p>
                              {{ userInfo.server_name
                              }}{{ userInfo.server_id }}服
                            </p>
                            <p>{{ userInfo.role_name }}</p>
                          </div>
                        </div>
                        <div
                          class="official-website-btn"
                          @click.stop="gotoWeb"
                        ></div>
                      </div>
                      <div
                        :class="
                          isGreaterThan5S && isAnimateList[5].isPlayAnimate
                            ? 'up-btn animated tada iteration'
                            : 'up-btn'
                        "
                        @click.stop="upPage"
                      ></div>
                      <div
                        :class="
                          isGreaterThan5S && isAnimateList[5].isPlayAnimate
                            ? 'next-btn animated tada iteration'
                            : 'next-btn'
                        "
                        @click.stop="nextPage"
                      ></div>
                    </div>
                    <div v-else class="fifth-act-box-1" :style="slideStyle">
                      <div class="projector-lamp"></div>
                      <div
                        :class="
                          isAnimateList[5].isPlayAnimate
                            ? 'snail animated fadeInLeftBig'
                            : 'snail'
                        "
                        v-if="swiperIndex == 5"
                      ></div>
                      <div
                        :class="
                          isAnimateList[5].isPlayAnimate
                            ? 'deer animated fadeInRightBig delay5s'
                            : 'deer'
                        "
                        v-if="swiperIndex == 5"
                      ></div>
                      <div
                        :class="
                          isAnimateList[5].isPlayAnimate
                            ? 'tiger-right animated fadeInRightBig delay5s'
                            : 'tiger-right'
                        "
                        v-if="swiperIndex == 5"
                      ></div>
                      <div
                        :class="
                          isAnimateList[5].isPlayAnimate
                            ? 'dialog-box-4 animated zoomIn delay125s'
                            : 'dialog-box-4'
                        "
                        v-if="swiperIndex == 5"
                      >
                        <p>
                          你好{{
                            user_userInfo.role_name
                          }}，我是正在探索远古纪元的你，对的，这是一封即来自远古，却又来自未来的信！
                        </p>
                      </div>
                      <div
                        :class="
                          isAnimateList[5].isPlayAnimate
                            ? 'dialog-box-5 animated zoomIn delay175s'
                            : 'dialog-box-5'
                        "
                        v-if="swiperIndex == 5"
                      >
                        <p>
                          重启的号角已然吹响，我带领着源兽大军，正在探索成神的奥秘，你也是时候该动身了！
                        </p>
                      </div>
                      <div class="curtain"></div>
                      <div class="btn-box">
                        <div
                          :class="
                            userInfo.times > 0
                              ? 'lottery-btn animated swing iteration duration2s'
                              : 'lottery-btn'
                          "
                          @click="isShowLotteryDialog"
                        >
                          <div
                            class="red"
                            v-if="!userInfo.phone && userInfo.is_get_prize"
                          ></div>
                        </div>
                        <div
                          class="detail-btn"
                          @click="isShowActivityDetailDialog"
                        ></div>
                        <div
                          class="music-btn"
                          v-if="isShowMusicBtn"
                          @click="musicClick(false)"
                        ></div>
                        <div
                          v-else
                          class="music-close"
                          @click="musicClick(true)"
                        ></div>
                      </div>
                      <div class="btn-box-1">
                        <div
                          v-if="!userInfo.role_name"
                          class="login-btn"
                          @click.stop="changeLoginPopup(true)"
                        ></div>
                        <div
                          v-if="
                            userInfo.role_name && !isChannel(userInfo.channel)
                          "
                          class="change-btn"
                          @click.stop="changeOsPopup(true)"
                        >
                          <div class="user-info" v-if="userInfo.role_name">
                            <p>
                              {{ userInfo.server_name
                              }}{{ userInfo.server_id }}服
                            </p>
                            <p>{{ userInfo.role_name }}</p>
                          </div>
                        </div>
                        <div
                          v-if="
                            userInfo.role_name && isChannel(userInfo.channel)
                          "
                          class="exit"
                          @click.stop="logout"
                        >
                          <div class="user-info" v-if="userInfo.role_name">
                            <p>
                              {{ userInfo.server_name
                              }}{{ userInfo.server_id }}服
                            </p>
                            <p>{{ userInfo.role_name }}</p>
                          </div>
                        </div>
                        <div
                          class="official-website-btn"
                          @click.stop="gotoWeb"
                        ></div>
                      </div>
                      <div
                        :class="
                          isGreaterThan5S && isAnimateList[5].isPlayAnimate
                            ? 'up-btn animated tada iteration'
                            : 'up-btn'
                        "
                        @click.stop="upPage"
                      ></div>
                      <div
                        :class="
                          isGreaterThan5S && isAnimateList[5].isPlayAnimate
                            ? 'next-btn animated tada iteration'
                            : 'next-btn'
                        "
                        @click.stop="nextPage"
                      ></div>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="sixth-act-box" :style="slideStyle">
                      <div
                        :class="
                          isAnimateList[6].isPlayAnimate
                            ? 'taoist-priest animated fadeInLeftBig delay125s'
                            : 'taoist-priest'
                        "
                        v-if="swiperIndex == 6"
                      ></div>
                      <div
                        :class="
                          isAnimateList[6].isPlayAnimate
                            ? 'monkey animated fadeInLeftBig delay125s'
                            : 'monkey'
                        "
                        v-if="swiperIndex == 6"
                      ></div>
                      <div
                        :class="
                          isAnimateList[6].isPlayAnimate
                            ? 'snail animated fadeInLeftBig'
                            : 'snail'
                        "
                        v-if="swiperIndex == 6"
                      ></div>
                      <div
                        :class="
                          isAnimateList[6].isPlayAnimate
                            ? 'newspaper-seller animated fadeInRightBig delay5s'
                            : 'newspaper-seller'
                        "
                        v-if="swiperIndex == 6"
                      ></div>
                      <div
                        :class="
                          isAnimateList[6].isPlayAnimate
                            ? 'dragon animated fadeInRightBig delay175s'
                            : 'dragon'
                        "
                        v-if="swiperIndex == 6"
                      ></div>
                      <div
                        :class="
                          isAnimateList[6].isPlayAnimate
                            ? 'blue-cat animated fadeInRightBig delay125s'
                            : 'blue-cat'
                        "
                        v-if="swiperIndex == 6"
                      ></div>
                      <div class="coloured-ribbon"></div>
                      <div
                        :class="
                          isAnimateList[6].isPlayAnimate
                            ? 'dialog-box-1 animated zoomIn delay-1s'
                            : 'dialog-box-1'
                        "
                        v-if="swiperIndex == 6"
                      >
                        <p>
                          时至今日，已有<span>1440万</span>穿越者接到了任务，前往执行！
                        </p>
                      </div>
                      <div
                        :class="
                          isAnimateList[6].isPlayAnimate
                            ? 'dialog-box-2 animated zoomIn delay250s'
                            : 'dialog-box-2'
                        "
                        v-if="swiperIndex == 6"
                      >
                        <p>
                          蜗牛公益，携手同行！在过往的公益活动中，共有<span>332万</span>名蜗爷贡献出了自己的爱心，世界因鹂而美好~
                        </p>
                      </div>
                      <div
                        :class="
                          isAnimateList[6].isPlayAnimate
                            ? 'dialog-box-3 animated zoomIn delay15s'
                            : 'dialog-box-3'
                        "
                        v-if="swiperIndex == 6"
                      >
                        <p>
                          在源兽崛起中，蜗爷们最爱驯化的源兽是<span>凯门鳄</span>；蜗族的源兽大军日渐壮大,蜗们蜗族正在崛起！
                        </p>
                      </div>
                      <div class="curtain"></div>
                      <div class="btn-box">
                        <div
                          :class="
                            userInfo.times > 0
                              ? 'lottery-btn animated swing iteration duration2s'
                              : 'lottery-btn'
                          "
                          @click="isShowLotteryDialog"
                        >
                          <div
                            class="red"
                            v-if="!userInfo.phone && userInfo.is_get_prize"
                          ></div>
                        </div>
                        <div
                          class="detail-btn"
                          @click="isShowActivityDetailDialog"
                        ></div>
                        <div
                          class="music-btn"
                          v-if="isShowMusicBtn"
                          @click="musicClick(false)"
                        ></div>
                        <div
                          v-else
                          class="music-close"
                          @click="musicClick(true)"
                        ></div>
                      </div>
                      <div class="btn-box-1">
                        <div
                          v-if="!userInfo.role_name"
                          class="login-btn"
                          @click.stop="changeLoginPopup(true)"
                        ></div>
                        <div
                          v-if="
                            userInfo.role_name && !isChannel(userInfo.channel)
                          "
                          class="change-btn"
                          @click.stop="changeOsPopup(true)"
                        >
                          <div class="user-info" v-if="userInfo.role_name">
                            <p>
                              {{ userInfo.server_name
                              }}{{ userInfo.server_id }}服
                            </p>
                            <p>{{ userInfo.role_name }}</p>
                          </div>
                        </div>
                        <div
                          v-if="
                            userInfo.role_name && isChannel(userInfo.channel)
                          "
                          class="exit"
                          @click.stop="logout"
                        >
                          <div class="user-info" v-if="userInfo.role_name">
                            <p>
                              {{ userInfo.server_name
                              }}{{ userInfo.server_id }}服
                            </p>
                            <p>{{ userInfo.role_name }}</p>
                          </div>
                        </div>
                        <div
                          class="official-website-btn"
                          @click.stop="gotoWeb"
                        ></div>
                      </div>
                      <div
                        :class="
                          isGreaterThan5S && isAnimateList[6].isPlayAnimate
                            ? 'up-btn animated tada iteration'
                            : 'up-btn'
                        "
                        @click.stop="upPage"
                      ></div>
                      <div
                        :class="
                          isGreaterThan5S && isAnimateList[6].isPlayAnimate
                            ? 'next-btn animated tada iteration'
                            : 'next-btn'
                        "
                        @click.stop="nextPage"
                      ></div>
                    </div>
                  </div>
                  <div class="swiper-slide">
                    <div class="summarize-box" :style="slideStyle">
                      <div class="middle"></div>
                      <div class="wrap-bg" v-show="!shareShow">
                        <div class="wrap">
                          <div
                            class="five-dimensions"
                            id="five-dimensions-summarize"
                            :style="
                              isTablet
                                ? 'width: 100px;height: 100px'
                                : 'width: 65px;height: 65px'
                            "
                          ></div>
                          <div class="popularity">
                            <span>{{ user_activity.popularity }}</span>
                          </div>
                          <div class="knowledge">
                            {{ user_activity.knowledge }}
                          </div>
                          <div class="charisma">
                            {{ user_activity.charisma }}
                          </div>
                          <div class="wit">{{ user_activity.wit }}</div>
                          <div class="luck">{{ user_activity.luck }}</div>
                        </div>
                        <div class="total-score">
                          {{ totalScoreText(user_activity.total_score)
                          }}<span v-if="user_activity.total_score > 10000">{{
                            user_activity.total_score > 100000000 ? "亿" : "万"
                          }}</span>
                        </div>
                        <div class="max-lottery-eucal">
                          {{
                            user_activity.max_lottery_eucal &&
                            user_activity.max_lottery_eucal[0]
                              ? user_activity.max_lottery_eucal[0]
                              : 0
                          }}
                        </div>
                        <div class="best-equip-name">
                          <span>
                            {{ user_activity.best_equip_name
                            }}<span
                              class="color-style"
                              v-if="user_activity.best_equip_step > 0"
                              >+{{ user_activity.best_equip_step }}</span
                            >
                          </span>
                        </div>
                        <div class="card-bonus-amount">
                          {{ user_activity.card_bonus_amount }}条
                        </div>
                        <div class="collection-count-5">
                          {{ user_activity.collection_count_5 }}个
                        </div>
                        <div class="sign">
                          {{ user_activity.sign ? user_activity.sign : 0 }}天
                        </div>
                        <div class="describe-select" @click="isShowTapDialog">
                          {{ describeSelectName }}
                        </div>
                        <div class="nickname-select" @click="isShowTapDialog">
                          {{ nicknameSelectName }}
                        </div>
                        <div
                          class="btn"
                          @click="onCopy()"
                          id="clipboard-btn"
                          data-event="复制邀请链接"
                          :data-clipboard-text="
                            '福利|最强蜗牛三周年年度报告出炉！限定头像等你拿！：' +
                              shareLink
                          "
                        ></div>
                        <div class="back-homepage" @click="upPage"></div>
                      </div>
                      <div class="hand" v-show="!shareShow"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 注销弹窗 -->
        <div class="logout-wrap popup_wrap1" v-show="logoutShow">
          <transition
            enter-active-class="animated zoomInNew"
            leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }"
          >
            <div class="popup-wrap-box" v-show="logoutShow">
              <h2>确定退出当前用户</h2>
              <div>
                <a href="javascript:;" @click="logoutShow = false">取消</a>
                <a href="javascript:;" @click="logoutBtn()">确认</a>
              </div>
            </div>
          </transition>
        </div>

        <!-- 提示弹窗 -->
        <div :class="'tips-wrap tips-wrap-' + tipsShow">
          <div :class="'show-' + tipsShow2">
            <p>{{ tips }}</p>
          </div>
        </div>

        <!-- 分享弹窗 -->
        <div class="help-share-wrap popup_wrap1" v-show="shareShow">
          <transition
            enter-active-class="animated zoomInNew"
            leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }"
          >
            <div class="help-share-box popup_wrap-box" v-show="shareShow">
              <div
                class="close-bg"
                v-show="shareShow"
                @click="shareShow = false"
              ></div>
              <img :src="shareImg" alt="分享图片" />
              <div class="hand" @click="shareShow = false"></div>
              <div class="back-home" @click="backHomepage(true)"></div>
            </div>
          </transition>
        </div>

        <Dialog
          ref="dialogRef"
          @createRandom="createRandom"
          @lotteryTime="lotteryTime"
          @requestAddress="requestAddress"
          @changeTime="changeTime"
          @tipsMessage="tipsMessage"
          @requestLotteryDetail="requestLotteryDetail"
          @backHomepage="backHomepage"
          @describeConfirm="describeConfirm"
        ></Dialog>
      </div>

      <!-- 分享相关DOM -->
      <div class="share-box" ref="imageDom">
        <img
          src="https://download4.qcplay.com/snail/triennial/share/bg.png"
        />
        <div class="role-name">
          {{ user_userInfo.server_name }}{{ user_userInfo.server_id }}服
          {{ user_userInfo.role_name }}
        </div>
        <div class="describe">
          {{ describeSelectName }}{{ nicknameSelectName }}
        </div>
        <div class="wrap">
          <div
            class="five-dimensions"
            id="five-dimensions"
            style="width: 75px;height: 75px"
          ></div>
          <div class="popularity">
            <span>{{ user_activity.popularity }}</span>
          </div>
          <div class="knowledge">{{ user_activity.knowledge }}</div>
          <div class="charisma">{{ user_activity.charisma }}</div>
          <div class="wit">{{ user_activity.wit }}</div>
          <div class="luck">{{ user_activity.luck }}</div>
        </div>
        <div class="total-score">
          {{ totalScoreText(user_activity.total_score)
          }}<span v-if="user_activity.total_score > 10000">{{
            user_activity.total_score > 100000000 ? "亿" : "万"
          }}</span>
        </div>
        <div class="max-lottery-eucal">
          {{
            user_activity.max_lottery_eucal &&
            user_activity.max_lottery_eucal[0]
              ? user_activity.max_lottery_eucal[0]
              : 0
          }}
        </div>
        <div class="best-equip-name">
          <div>
            {{ user_activity.best_equip_name
            }}<span v-if="user_activity.best_equip_step > 0"
              >+{{ user_activity.best_equip_step }}</span
            >
          </div>
        </div>
        <div class="card-bonus-amount">
          {{ user_activity.card_bonus_amount }}条
        </div>
        <div class="collection-count-5">
          {{ user_activity.collection_count_5 }}个
        </div>
        <div class="sign">
          {{ user_activity.sign ? user_activity.sign : 0 }}天
        </div>
        <div class="qrcode-box">
          <div id="qrcode" class="qrcode"></div>
        </div>
      </div>

      <!-- 登陆模块 -->
      <Login
        v-if="isShowLogin"
        v-on:channelCallback="selectCallback"
        :gameName="gameName"
        :loginTypes="loginTypes"
        downloadUrl="https://static.qcplay.com/tideng/official/"
        channelTips="UID可在游戏中—设置—UID查看"
      ></Login>
      <Os
        v-if="isShowOs"
        v-on:selectCallback="selectCallback"
        v-on:logoutCallback="osCancell"
        :gameName="gameName"
      ></Os>
    </div>
  </div>
</template>
<script>
import Clipboard from "clipboard";
import Os from "@/components/os";
import Login from "@/components/login";
import { mapState, mapMutations, mapActions } from "vuex";
import {
  onGetInitDataAPI,
  easterEggRewardAPI,
  lotteryAPI,
  lotteryDetailAPI,
  addressAPI,
  LogoutAPI
} from "../api";
import { getTimeStamp, buriedLogger } from "@/utils/utils";
import { generateQRCode, generateCanvasImage } from "@/utils/share";
import Swiper from "swiper";
import Dialog from "../components/dialog.vue";
import "../../../../assets/js/howler";

export default {
  components: {
    Login,
    Os,
    Dialog
  },
  data() {
    return {
      gameName: "snail",
      logger: null,
      homeShow: false,
      // 其他数据
      loginTypes: ["sms", "password", "channel"],
      user_activity: "",
      user_userInfo: "",
      logoutShow: false,
      logoutBtnClase: true,
      // 分享弹窗
      shareShow: false,
      shareImg: "",
      shareLink: "",
      swiper: null,
      // silder样式
      slideStyle: "",
      // silder索引
      swiperIndex: 0,
      // 是否要播放动画 isPlayAnimate:是否需要播放动画，isNext是否动画播放完成可以进入下一页
      isAnimateList: [
        { isPlayAnimate: false },
        { isPlayAnimate: true, isNext: false },
        { isPlayAnimate: true, isNext: false },
        { isPlayAnimate: true, isNext: false },
        { isPlayAnimate: true, isNext: false },
        { isPlayAnimate: true, isNext: false },
        { isPlayAnimate: true, isNext: false },
        { isPlayAnimate: false }
      ],
      // 是否显示万
      isShowMyriad: false,
      // 抽奖随机数
      random: 0,
      // 抽奖计时器
      lotteryTimer: null,
      time: 0,
      // 定时器
      timer: null,
      // 标签一
      describeSelectName: "欧气爆棚的",
      // 标签二
      nicknameSelectName: "蜗牛",
      //是否是平板
      isTablet: false,
      // 是否再次观看
      isAgain: false,
      // 提示语
      tips: "",
      // 提示显示1
      tipsShow: false,
      // 提示显示2
      tipsShow2: false,
      // 计算当前页面停留时间定时器
      swiperIndexTimer: null,
      // 是否停留超过五秒
      isGreaterThan5S: false,
      // 音乐文件地址
      mp3url: "",
      // 是否显示音乐按钮
      isShowMusicBtn: true,
      // howler自动播放音乐
      hitMusic: {}
    };
  },
  created() {
    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();
    // 埋点
    const bl = buriedLogger("snail", "蜗牛_三周年");
    this.logger = bl;
    const ua = navigator.userAgent;
    const isAndroid = /(?:Android)/.test(ua);
    const isFireFox = /(?:Firefox)/.test(ua);
    this.isTablet =
      /(?:iPad|PlayBook)/.test(ua) ||
      (isAndroid && !/(?:Mobile)/.test(ua)) ||
      (isFireFox && /(?:Tablet)/.test(ua));
  },
  mounted() {
    this.$nextTick(() => {
      this.forceLandscapeScreenHandle();
      this.onWindowSizeChanged();
      this.startLoading();
      this.swiperInit();
      this.echartsInit();
      this.requestLotteryDetail();
      this.isSetShare();
      this.hitMusic = new Howl({
        preload: true,
        loop: false,
        src: [
          require("../../../../assets/images/active/snail/triennial/start/music.mp3")
        ]
      });
      this.hitMusic.play();
    });
  },
  computed: {
    ...mapState(["userInfo", "activeInfo", "isShowLogin", "isShowOs"])
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        if (!newValue.rid) {
          // TAG: 注销的时候
          this.shareImg = "";
          this.swiperIndex = 0;
          if (this.swiper) {
            this.swiper.slideTo(0);
          }
          this.isAgain = false;
        } else if (newValue.rid !== oldValue.rid) {
          this.backHomepage();
          this.isAgain = false;
          // TAG: 初始登陆/切换角色的时候
          const { protocol, host } = window.location;
          this.shareLink = `${protocol}//${host}/snail/triennial/enter${getTimeStamp()}`;
          this.echartsInit();
          this.requestLotteryDetail();
          window.setTimeout(() => {
            this.initShareData(newValue);
          }, 200);
        }
      }
    },
    swiperIndex: {
      handler(newValue, oldValue) {
        if (newValue === 1 && this.isAnimateList[1].isPlayAnimate) {
          setTimeout(() => {
            this.isAnimateList[1].isNext = true;
          }, 2500);
        } else if (newValue === 2 && this.isAnimateList[2].isPlayAnimate) {
          setTimeout(() => {
            this.isAnimateList[2].isNext = true;
          }, 2800);
        } else if (newValue === 3 && this.isAnimateList[3].isPlayAnimate) {
          setTimeout(() => {
            this.isAnimateList[3].isNext = true;
          }, 3100);
        } else if (newValue === 4 && this.isAnimateList[4].isPlayAnimate) {
          if (this.user_activity.join_group_time > 0) {
            setTimeout(() => {
              this.isAnimateList[4].isNext = true;
            }, 3200);
          } else {
            setTimeout(() => {
              this.isAnimateList[4].isNext = true;
            }, 2200);
          }
        } else if (newValue === 5 && this.isAnimateList[5].isPlayAnimate) {
          setTimeout(() => {
            this.isAnimateList[5].isNext = true;
          }, 2700);
        } else if (newValue === 6 && this.isAnimateList[6].isPlayAnimate) {
          setTimeout(() => {
            this.isAnimateList[6].isNext = true;
          }, 3200);
        }
      }
    },
    describeSelectName: {
      handler(newValue, oldValue) {
        if (newValue != oldValue) {
          this.initShareData();
        }
      }
    },
    nicknameSelectName: {
      handler(newValue, oldValue) {
        if (newValue != oldValue) {
          this.initShareData();
        }
      }
    }
  },
  methods: {
    swiperInit() {
      this.swiper = new Swiper(".swiper-bg-warp", {
        effect: "fade",
        spaceBetween: 0,
        speed: 500
      });
    },
    // 上一页
    upPage() {
      if (
        !this.isAnimateList[this.swiperIndex].isPlayAnimate ||
        (this.isAnimateList[this.swiperIndex].isPlayAnimate &&
          this.isAnimateList[this.swiperIndex].isNext)
      ) {
        this.isAnimateList[this.swiperIndex].isPlayAnimate = false;
        --this.swiperIndex;
        this.swiper.slidePrev();
      }
    },
    // 下一页
    nextPage() {
      // if (!this.userInfo.role_name) {
      //   return this.changeLoginPopup(true);
      // }
      if (
        !this.isAnimateList[this.swiperIndex].isPlayAnimate ||
        (this.isAnimateList[this.swiperIndex].isPlayAnimate &&
          this.isAnimateList[this.swiperIndex].isNext)
      ) {
        this.isGreaterThan5S = false;
        ++this.swiperIndex;
        this.swiper.slideNext();
        this.isAnimateList[this.swiperIndex - 1].isPlayAnimate = false;
        if (this.swiperIndexTimer) {
          clearTimeout(this.swiperIndexTimer);
          this.swiperIndexTimer = setTimeout(() => {
            this.isGreaterThan5S = true;
          }, 5000);
        } else {
          this.swiperIndexTimer = setTimeout(() => {
            this.isGreaterThan5S = true;
          }, 5000);
        }
      }
    },
    // 适配
    forceLandscapeScreenHandle() {
      if (document.activeElement.nodeName === "INPUT") return; // 兼容安卓
      let width = document.documentElement.clientWidth;
      let height = document.documentElement.clientHeight;
      var docEl = document.documentElement,
        fontH = window.innerWidth > window.innerHeight ? height : width;

      const el = document.getElementById("triennial-home-page");
      let style = "";
      if (width < height) {
        // 竖版
        style = `transform:rotate(90deg);transform-origin:${width /
          2}px center;width:${height}px;height:${width}px`;
        this.slideStyle = `width:${height}px;height:${width}px`;
      } else {
        // 横板
        setTimeout(() => {
          document.documentElement.style.fontSize = (75 * fontH) / 750 + "px";
          style = `transform:rotate(0deg);transform-origin:${width /
            2}px center;width:${width}px;height:${height}px`;
          this.slideStyle = `width:${width}px;height:${height}px`;
          if (el) el.style = style;
        }, 300);
      }
      if (el) el.style = style;
    },
    onWindowSizeChanged() {
      window.addEventListener("resize", this.forceLandscapeScreenHandle);
    },
    isReloadWindow(event) {
      return (
        !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) &&
        ((event && event.persisted) ||
          (window.performance &&
            window.performance.navigation &&
            window.performance.navigation.type === 2))
      );
    },
    startLoading() {
      // 防止第二次进入 微信底部有一个返回条，造成布局问题
      if (this.isReloadWindow()) {
        window.location.reload();
        return;
      }
      // 初始化
      this.getLoginContainer();
    },
    // 初始化
    getLoginContainer() {
      onGetInitDataAPI().then(response => {
        // 标签一数组
        (this.$refs.dialogRef.describeSelectList = [
          { name: "欧气爆棚的", id: 1 },
          { name: "氪金变强的", id: 2 },
          { name: "疯狂进化的", id: 3 },
          { name: "真香警告的", id: 4 },
          { name: "整点薯条的", id: 5 },
          { name: "不讲武德的", id: 6 },
          { name: "觉醒替身的", id: 7 },
          { name: "前往弑神的", id: 9 },
          { name: "热心公益的", id: 10 },
          { name: "变成西瓜头的", id: 14 },
          { name: "少女祈祷中的", id: 15 },
          { name: "最懂蜗牛的", id: 16 },
          { name: "脚穿切尔西的", id: 17 },
          { name: "吸收氮磷钾的", id: 18 },
          { name: "练习两年半的", id: 19 },
          { name: "保留原味的", id: 20 }
        ]),
          // 标签二数组
          (this.$refs.dialogRef.nicknameSelectList = [
            { name: "蜗牛", id: 1 },
            { name: "黄鹂鸟", id: 2 },
            { name: "独眼巨人", id: 3 },
            { name: "穿越者", id: 4 },
            { name: "咕咕鸽子", id: 5 },
            { name: "食腐活尸", id: 6 },
            { name: "鲜血恶魔", id: 7 },
            { name: "裂变异种", id: 9 },
            { name: "战车机械", id: 10 },
            { name: "下头蜗", id: 14 },
            { name: "修女和鱼", id: 15 },
            { name: "川建国", id: 16 },
            { name: "蓝色妖姬", id: 17 },
            { name: "金坷垃", id: 18 },
            { name: "小鸡子", id: 19 },
            { name: "九转大肠", id: 20 }
          ]),
          (this.homeShow = true);
        if (Number(response.code) == 200) {
          this.user_activity = response.data.activity;
          this.user_userInfo = response.data.userinfo;
          this.$refs.dialogRef.name = response.data.userinfo.name;
          this.$refs.dialogRef.phone = response.data.userinfo.phone;
          this.$refs.dialogRef.name1 = response.data.userinfo.name;
          this.$refs.dialogRef.phone1 = response.data.userinfo.phone;
          let index = -2;
          let lengthIndex = -1;
          if (
            response.data.userinfo.address.indexOf("-S") != -1 ||
            response.data.userinfo.address.indexOf("-M") != -1 ||
            response.data.userinfo.address.indexOf("-L") != -1
          ) {
            index = -2;
            lengthIndex = -1;
          } else if (response.data.userinfo.address.indexOf("-XL") != -1) {
            index = -3;
            lengthIndex = -2;
          } else {
            index = -4;
            lengthIndex = -3;
          }
          this.$refs.dialogRef.area = response.data.userinfo.address
            ? response.data.userinfo.address.slice(0, index)
            : "";
          this.$refs.dialogRef.area1 = response.data.userinfo.address
            ? response.data.userinfo.address.slice(0, index)
            : "";
          this.$refs.dialogRef.size =
            response.data.userinfo.address.length > 0
              ? response.data.userinfo.address.slice(lengthIndex)
              : "S";
          this.$refs.dialogRef.clothesSize =
            response.data.userinfo.address.length > 0
              ? response.data.userinfo.address.slice(lengthIndex)
              : "S";
          this.$refs.dialogRef.activity = response.data.activity;
          this.$refs.dialogRef.lotteryCount = response.data.userinfo.times;
          this.$refs.dialogRef.is_get_prize = this.user_userInfo.is_get_prize;
          if (response.data.activity.god_total > 0) {
            this.$refs.dialogRef.describeSelectList.push({
              name: "许愿神龙的",
              id: 8
            });
            this.$refs.dialogRef.nicknameSelectList.push({
              name: "肌肉天使",
              id: 8
            });
          }
          if (response.data.activity.godhood_grade > 0) {
            this.$refs.dialogRef.describeSelectList.push({
              name: "成为蜗神的",
              id: 11
            });
            this.$refs.dialogRef.nicknameSelectList.push({
              name: "吐息巨龙",
              id: 11
            });
          }
          if (response.data.activity.pet_book_count > 0) {
            this.$refs.dialogRef.describeSelectList.push({
              name: "捕捉源兽的",
              id: 12
            });
            this.$refs.dialogRef.nicknameSelectList.push({
              name: "大力王",
              id: 12
            });
          }
          if (response.data.activity.cook_score > 0) {
            this.$refs.dialogRef.describeSelectList.push({
              name: "烹饪美食的",
              id: 13
            });
            this.$refs.dialogRef.nicknameSelectList.push({
              name: "happy猫",
              id: 13
            });
          }
          this.onInitDataCallback(response);
          this.setUserInfo(response.data.userinfo);
          return;
        }
        //未授权
        if (Number(response.code) == 302) {
          var ua = navigator.userAgent.toLowerCase();
          if (ua.match(/MicroMessenger/i) == "micromessenger") {
            // 如果在微信里面
            window.location.href =
              response.data["wechat_url"] +
              "?callback=" +
              encodeURI(window.location.href);
            return;
          } else {
            // 如果在QQ里面
            window.location.href =
              response.data["qq_url"] +
              "?callback=" +
              encodeURI(window.location.href);
            return;
          }
        }
        // 登录异常
        if (Number(response.code) == 401 && response.data.info) {
          this.onInitDataCallback(response);
          this.tipsMessage("信息加载失败，请先登入游戏", 2000);
          return;
        }
        // 请登录
        if (Number(response.code) == 401) {
          this.onInitDataCallback(response);
          return;
        }
      });
    },
    // 彩蛋奖励
    requestEasterEggReward(id) {
      this.logger.sum("蜗牛三周年_彩蛋奖励领取");
      easterEggRewardAPI({ package_id: id }).then(response => {
        if (response.code == 200) {
          if (id == "1") {
            this.$refs.dialogRef.isShowEasterEgg1 = true;
          } else if (id == "2") {
            this.$refs.dialogRef.isShowEasterEgg2 = true;
          } else if (id == "3") {
            this.$refs.dialogRef.isShowEasterEgg3 = true;
          } else if (id == "4") {
            this.$refs.dialogRef.isShowEasterEgg4 = true;
          }
        } else {
          if (id == "1") {
            this.$refs.dialogRef.isShowEasterEgg1_1 = true;
          } else if (id == "2") {
            this.$refs.dialogRef.isShowEasterEgg2_1 = true;
          } else if (id == "3") {
            this.$refs.dialogRef.isShowEasterEgg3_1 = true;
          } else if (id == "4") {
            this.$refs.dialogRef.isShowEasterEgg4_1 = true;
          }
        }
      });
    },
    // 返回首页
    backHomepage(value) {
      if (value) {
        this.isAgain = true;
      }
      this.shareShow = false;
      this.swiperIndex = 0;
      this.swiper.slideTo(0);
    },
    // 抽奖
    requestLottery() {
      this.logger.sum("蜗牛三周年_抽奖按钮");
      lotteryAPI().then(response => {
        // clearTimeout(this.timer);
        clearTimeout(this.lotteryTimer);
        if (response.code == 200) {
          this.random = response.data.prize_id;
          // 随机数抽奖方式
          // this.$refs.dialogRef.random = response.data.prize_id;
          // 顺时针抽奖方式
          this.$refs.dialogRef.prizeId = response.data.prize_id;
          this.time = 0;
          // 随机数抽奖方式
          // this.$refs.dialogRef.time = 0;
          // this.requestLotteryDetail();
          this.getLoginContainer();
        } else {
          this.$refs.dialogRef.time = 0;
          this.$refs.dialogRef.prizeId = -1;
          this.$refs.dialogRef.random = 0;
          clearTimeout(this.$refs.dialogRef.timer);
          this.time = 0;
          this.tipsMessage(response.message, 2000);
        }
      });
    },
    // 抽奖详情
    requestLotteryDetail() {
      lotteryDetailAPI().then(response => {
        if (response.code == 200) {
          this.$refs.dialogRef.lotteryDetailList = response.data.list;
        } else {
          this.tipsMessage(response.message, 2000);
        }
      });
    },
    // 生成随机数
    createRandom() {
      if (this.user_userInfo.times == 0) {
        return;
      }
      let Random = Math.floor(Math.random() * 9) + 1;
      if (this.random != Random) {
        this.random = Random;
        this.$refs.dialogRef.random = this.random;
        this.timer = setTimeout(() => {
          this.createRandom();
        }, 300);
      } else {
        this.createRandom();
      }
    },
    // 抽奖闪烁计时器
    lotteryTime() {
      if (this.user_userInfo.times == 0) {
        this.tipsMessage("很抱歉,您已经没有抽奖次数了", 2000);
        return;
      }
      this.time = this.time + 1;
      this.$refs.dialogRef.time = this.time;
      if (this.time < 3.5) {
        this.lotteryTimer = setTimeout(() => {
          this.lotteryTime();
        }, 1000);
      } else {
        this.requestLottery();
      }
    },
    // 转换时间time
    changeTime(time) {
      this.time = time;
    },
    // 填写收货地址
    requestAddress(addressInfo) {
      this.logger.sum("蜗牛三周年_填写收货地址按钮");
      addressAPI(addressInfo).then(response => {
        if (response.code == 200) {
          this.tipsMessage("保存成功", 2000);
          this.getLoginContainer();
        } else {
          this.tipsMessage(response.message, 2000);
        }
      });
    },
    // 打开抽奖弹窗
    isShowLotteryDialog() {
      if (!this.userInfo.role_name) {
        return this.changeLoginPopup(true);
      }
      this.$refs.dialogRef.isShowLottery = true;
    },
    // 打开选择标签弹窗
    isShowTapDialog() {
      this.$refs.dialogRef.isShowTapDialog = true;
    },
    // 选择标签确定事件
    describeConfirm(describeSelectName, nicknameSelectName) {
      this.describeSelectName = describeSelectName;
      this.nicknameSelectName = nicknameSelectName;
    },
    // 跳转到官网
    gotoWeb() {
      window.location.href =
        "http://static.qcplay.com/snail/official/index.html";
    },
    // 背景音乐点击事件
    musicClick(value) {
      if (value) {
        this.isShowMusicBtn = true;
        this.hitMusic.play();
      } else {
        this.isShowMusicBtn = false;
        this.hitMusic.stop();
      }
    },
    // 打开活动详情弹窗
    isShowActivityDetailDialog() {
      this.$refs.dialogRef.isShowActivityDetail = true;
    },
    echartsInit() {
      const echarts = window.echarts || echarts;
      const chartDom = document.getElementById("five-dimensions");
      const chartDomSummarize = document.getElementById(
        "five-dimensions-summarize"
      );
      const myChart = echarts.init(chartDom);
      const myChartSummarize = echarts.init(chartDomSummarize);
      const option = {
        color: ["#96cce2"],
        radar: {
          splitNumber: 1,
          indicator: [
            { name: "", max: 6 },
            { name: "", max: 6 },
            { name: "", max: 6 },
            { name: "", max: 6 },
            { name: "", max: 6 }
          ],
          textStyle: {
            color: "#77716a",
            fontWeight: "bold",
            fontSize: 30,
            fontFamily: "snail"
          },
          axisLine: {
            lineStyle: {
              color: "#BDBDBD",
              width: 1.1
            }
          },
          splitLine: {
            lineStyle: {
              color: "#828282",
              width: 1.1
            }
          },
          splitArea: {
            areaStyle: {
              color: "transparent"
            }
          },
          center: ["50%", "50%"],
          radius: "100%"
        },
        series: [
          {
            name: "ability",
            type: "radar",
            symbol: "none",
            data: [
              {
                value: [
                  this.fiveDimensionalValue(this.user_activity.popularity),
                  this.fiveDimensionalValue(this.user_activity.knowledge),
                  this.fiveDimensionalValue(this.user_activity.wit),
                  this.fiveDimensionalValue(this.user_activity.luck),
                  this.fiveDimensionalValue(this.user_activity.charisma)
                ],
                name: "ability-radar",
                areaStyle: {
                  color: "#7ec5ff"
                }
              }
            ]
          }
        ]
      };
      myChart.setOption(option);
      myChartSummarize.setOption(option);
    },
    // 计算五位图数值
    fiveDimensionalValue(value) {
      let text = 0;
      if (value >= 70000) {
        text = 6;
      } else if (60000 <= value && value < 70000) {
        text = value / 12000;
      } else if (40000 <= value && value < 60000) {
        text = value / 10000 / 2 + 3;
      } else if (20000 <= value && value < 40000) {
        text = value / 10000 / 2 + 2;
      } else if (value < 20000) {
        text = value / 10000 / 2 + 1;
      }
      return text;
    },
    // 初始化分享信息
    initShareData(info) {
      try {
        this.qrcode(`${this.shareLink}`);
        this.$nextTick(() => {
          this.generateShareImage();
        });
      } catch (err) {
        // 错误信息
        console.log("err", err);
      }
    },
    qrcode(link) {
      generateQRCode(document.getElementById("qrcode"), {
        text: link,
        colorDark: "#c1d3e9",
        colorLight: "#59769d"
      });
    },
    // 分享图片设置
    generateShareImage() {
      generateCanvasImage(this.$refs.imageDom)
        .then(canvas => {
          this.shareImg = canvas.toDataURL("image/png"); // 可将 canvas 转为 base64 格式
          console.log("success: 图片生成成功", canvas);
        })
        .catch(err => {
          console.log("err: 图片生成失败", err.message);
        });
    },
    // 复制链接
    onCopy() {
      const clipboard = new Clipboard("#clipboard-btn");
      clipboard.on("success", e => {
        this.tipsMessage("已成功复制分享链接", 2000);
        e.clearSelection();
      });
      clipboard.on("error", e => {
        this.tipsMessage("复制失败", 2000);
      });
      this.logger.sum("蜗牛三周年_复制链接按钮");
      this.shareShow = true;
      this.requestEasterEggReward("5");
    },
    // 渠道判断
    isChannel(channel) {
      if (channel === "android" || channel === "ios") {
        return false;
      } else {
        return true;
      }
    },
    // 时间戳转日期
    dateText(timestamp) {
      const date = new Date(timestamp);
      const Y = date.getFullYear();
      const M = date.getMonth() + 1;
      const D = date.getDate();
      let time = Y + "年" + M + "月" + D + "日";
      return time;
    },
    // 战力转文本
    totalScoreText(total_score) {
      let text = 0;
      if (total_score < 10000) {
        text = total_score;
        this.isShowMyriad = false;
      } else if (total_score > 10000 && total_score < 100000000) {
        text = (total_score / 10000).toFixed(0);
        this.isShowMyriad = true;
      } else {
        text = (total_score / 100000000).toFixed(2);
        this.isShowMyriad = true;
      }
      return text;
    },
    // 探索地图转文本
    tourMapText(tour_map_count) {
      let text = "";
      if (tour_map_count["9"] > 0) {
        text = "时空孔隙";
      } else if (tour_map_count["8"] > 0) {
        text = "天竺";
      } else if (tour_map_count["7"] > 0) {
        text = "希域";
      } else if (tour_map_count["6"] > 0) {
        text = "埃罗";
      } else if (tour_map_count["5"] > 0) {
        text = "英伦";
      } else if (tour_map_count["4"] > 0) {
        text = "米国";
      } else if (tour_map_count["3"] > 0) {
        text = "华夏";
      } else if (tour_map_count["2"] > 0) {
        text = "扶桑";
      } else if (tour_map_count["1"] > 0) {
        text = "高丽";
      }
      return text;
    },
    // 套装转文本
    suitText(max_kit_amount) {
      let text = "";
      if (max_kit_amount[0] === 1) {
        text = "敢死套件";
      } else if (max_kit_amount[0] === 2) {
        text = "勘探套件";
      } else if (max_kit_amount[0] === 3) {
        text = "苦力套件";
      }
      return text;
    },
    // 退出登录
    logout() {
      LogoutAPI().then(response => {
        if (Number(response.code) === 200) {
          // 清空数据 控制弹窗
          this.setInitUserInfo();
          this.setInitActiveInfo();
          this.changeLoginPopup(true);
        }
      });
    },
    selectCallback() {
      this.getLoginContainer();
    },
    osCancell() {
      // 清空数据
      this.getLoginContainer();
    },
    tipsMessage(message, times) {
      this.tipsShow = true;
      this.tips = message;
      setTimeout(() => {
        this.tipsShow2 = true;
      }, 100);
      setTimeout(() => {
        this.tipsShow2 = false;
      }, times - 200);
      setTimeout(() => {
        this.tipsShow = false;
        this.tips = "";
      }, times);
    },
    // TODO: 登陆弹窗demo
    openLoginOS() {
      if (this.userInfo.role_id) {
        this.changeOsPopup(true);
      } else {
        this.changeLoginPopup(true);
      }
    },
    isSetShare() {
      this.setShare({
        link: `https://h5.qingcigame.com/snail/triennial/enter${getTimeStamp()}`,
        title: "最强蜗牛三周年年度报告",
        imgUrl:
          "https://download4.qcplay.com/qcgame-admin/YRRtLdMhAin0uuKmRNNygrbXp1rwJHeaixqSa5eo.png",
        desc: "最强蜗牛三周年年度报告出炉！"
      });
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "confirmLogout",
      "setInitActiveInfo",
      "changeLoginPopup",
      "changeOsPopup"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  }
};
</script>

<style lang="less" scope>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/snail/triennial/index/index.vue